import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class NavigationUtilService {
	gotoCM(location: Location | { href: string }, path: string) {
		if (location.href.indexOf('http://localhost') > -1) {
			location.href = 'http://localhost:4200/' + path;
		} else {
			location.href = location.href.replace('sdmweb.scanburapps.com/cm/', 'cm.scanburapps.com/');
		}
	}
}
